(function () {
  const BAR_ID = 'fp-mini-cart-bar';
  const MIN_ORDER_PAISE = 19900;

  if (window.location.pathname === '/cart') return;

  let barEl = null;

  function injectStyles() {
    if (document.getElementById('fp-mini-cart-bar-styles')) return;
    const style = document.createElement('style');
    style.id = 'fp-mini-cart-bar-styles';
    style.textContent = `
      #fp-mini-cart-bar {
        position: fixed;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%) translateY(calc(100% + 24px));
        z-index: 500;
        background: var(--fp-green, #1e3a2f);
        color: var(--fp-white, #ffffff);
        font-family: var(--font-paragraph--family, 'Inter', sans-serif);
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 12px 10px 10px;
        border-radius: 20px;
        box-shadow: 0 4px 24px rgba(0,0,0,0.28);
        transition: transform 350ms cubic-bezier(0.34,1.56,0.64,1);
        white-space: nowrap;
        min-width: 280px;
        max-width: calc(100vw - 32px);
      }
      #fp-mini-cart-bar.fp-mini-cart--visible {
        transform: translateX(-50%) translateY(0);
      }
      #fp-mini-cart-bar.fp-mini-cart--above-sticky {
        bottom: calc(64px + 16px);
      }
      @media (min-width: 750px) {
        #fp-mini-cart-bar {
          bottom: 24px;
          padding: 10px 14px 10px 10px;
          min-width: 320px;
        }
        #fp-mini-cart-bar.fp-mini-cart--above-sticky {
          bottom: calc(72px + 24px);
        }
      }

      /* Icon tile */
      .fp-mcb__icon-box {
        position: relative;
        flex-shrink: 0;
        width: 46px;
        height: 46px;
        background: rgba(255,255,255,0.20);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .fp-mcb__icon-box svg {
        width: 22px;
        height: 22px;
        stroke: var(--fp-white, #fff);
        fill: none;
        stroke-width: 1.8px;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      /* Badge: top-LEFT of icon box */
      .fp-mcb__badge {
        position: absolute;
        top: -6px;
        left: -6px;
        background: var(--fp-orange, #E8824A);
        color: #fff;
        font-size: 10px;
        font-weight: 700;
        min-width: 18px;
        height: 18px;
        padding: 0 4px;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /* Text block */
      .fp-mcb__center {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        min-width: 0;
        gap: 1px;
      }
      .fp-mcb__min-order {
        font-size: 11px;
        color: var(--fp-white, #fff);
        opacity: 0.65;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }
      .fp-mcb__price-row {
        display: flex;
        align-items: baseline;
        gap: 6px;
      }
      .fp-mcb__subtotal {
        font-size: 16px;
        font-weight: 700;
        color: var(--fp-white, #fff);
      }
      .fp-mcb__saved {
        font-size: 12px;
        font-weight: 600;
        color: var(--fp-orange, #E8824A);
      }

      /* Button */
      .fp-mcb__btn {
        background: var(--fp-white, #fff);
        color: var(--fp-green, #1e3a2f);
        border: none;
        border-radius: 100px;
        padding: 10px 16px;
        font-weight: 700;
        font-size: 13px;
        font-family: inherit;
        cursor: pointer;
        flex-shrink: 0;
        transition: opacity 150ms ease;
        letter-spacing: 0.01em;
      }
      .fp-mcb__btn:hover { opacity: 0.88; }

      @media (max-width: 390px) {
        .fp-mcb__subtotal { font-size: 14px; }
        .fp-mcb__saved { font-size: 11px; }
        .fp-mcb__btn { padding: 9px 12px; font-size: 12px; }
        .fp-mcb__min-order { font-size: 10px; }
      }
    `;
    document.head.appendChild(style);
  }

  function formatRs(paise) {
    const rs = paise / 100;
    return 'Rs.' + (Number.isInteger(rs) ? rs : rs.toFixed(2));
  }

  function buildBar() {
    const bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.innerHTML = `
      <div class="fp-mcb__icon-box">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 01-8 0"/>
        </svg>
        <span class="fp-mcb__badge">0</span>
      </div>
      <div class="fp-mcb__center">
        <span class="fp-mcb__min-order" style="display:none">Minimum order size Rs 199</span>
        <div class="fp-mcb__price-row">
          <span class="fp-mcb__subtotal">Rs.0</span>
          <span class="fp-mcb__saved" style="display:none"></span>
        </div>
      </div>
      <button class="fp-mcb__btn" type="button">View Cart →</button>
    `;

    bar.querySelector('.fp-mcb__btn').addEventListener('click', function () {
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = '/cart';
      }
    });

    document.body.appendChild(bar);

    const atcBar = document.querySelector('.sticky-add-to-cart__bar');
    if (atcBar) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'data-stuck') {
            const stuck = atcBar.getAttribute('data-stuck') === 'true';
            bar.classList.toggle('fp-mini-cart--above-sticky', stuck);
          }
        });
      }).observe(atcBar, { attributes: true, attributeFilter: ['data-stuck'] });
    }

    return bar;
  }

  function getBar() {
    if (!barEl) { injectStyles(); barEl = buildBar(); }
    return barEl;
  }

  function updateBar(cart) {
    const bar = getBar();
    const count = cart.item_count || 0;
    const subtotalPaise = cart.items_subtotal_price || 0;

    if (count === 0) { bar.classList.remove('fp-mini-cart--visible'); return; }
    bar.classList.add('fp-mini-cart--visible');

    bar.querySelector('.fp-mcb__badge').textContent = count > 99 ? '99+' : count;
    bar.querySelector('.fp-mcb__subtotal').textContent = formatRs(subtotalPaise);

    const minOrderEl = bar.querySelector('.fp-mcb__min-order');
    const savedEl = bar.querySelector('.fp-mcb__saved');

    // Min order line
    minOrderEl.style.display = subtotalPaise < MIN_ORDER_PAISE ? '' : 'none';

    // Saved: sum compare_at_price * qty vs actual line_price across all items
    const savedPaise = (cart.items || []).reduce(function (sum, item) {
      const compareAt = item.compare_at_price || 0;
      const actual = item.price || 0;
      return sum + (compareAt > actual ? (compareAt - actual) * item.quantity : 0);
    }, 0);

    if (savedPaise > 0) {
      savedEl.textContent = 'Saved ' + formatRs(savedPaise);
      savedEl.style.display = '';
    } else {
      savedEl.style.display = 'none';
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(updateBar)
      .catch(function (err) { console.warn('[fp-mini-cart-bar] fetch error', err); });
  }

  document.addEventListener('cart:updated', function (e) {
    const cart = e.detail;
    if (cart && typeof cart.item_count !== 'undefined') {
      updateBar(cart);
    } else {
      fetchAndUpdate();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndUpdate);
  } else {
    fetchAndUpdate();
  }
})();
